import React, { useState } from "react";
import "./ContactUs.scss";
import { createContactList } from "services/contactus/contactusadd";

const ContactPageNew = () => {
  const [formData, setFormData] = useState({
    Name: "",
    EmailId: "",
    Mobile: "",
    Comment: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");


    const { Name, EmailId, Mobile, Comment } = formData;
    // Validation: Name, Email, Mobile, Comment are required
    if (!Name || Name.trim().length < 5) {
      setErrorMsg("Please enter a valid name (at least 5 characters).");
      setLoading(false);
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!EmailId || !emailRegex.test(EmailId)) {
      setErrorMsg("Please enter a valid email address.");
      setLoading(false);
      return;
    }

    // Mobile validation
    const mobileRegex = /^[0-9]{10}$/;
    if (!Mobile || !mobileRegex.test(Mobile)) {
      setErrorMsg("Please enter a valid 10-digit mobile number.");
      setLoading(false);
      return;
    }

    // Comment validation
    if (!Comment || Comment.trim().length < 5) {
      setErrorMsg("Please enter a message (at least 5 characters).");
      setLoading(false);
      return;
    }


    try {
      // Prepare payload for backend
      const payload = {
        name: formData.Name,
        emailid: formData.EmailId,
        mobile: formData.Mobile,
        comment: formData.Comment,
      };

      const response = await createContactList(payload);

      setSuccessMsg(response.message || "Your message has been sent!");
      setFormData({ Name: "", EmailId: "", Mobile: "", Comment: "" }); // reset form
    } catch (err) {
      console.error(err);
      setErrorMsg("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cp-wrapper">
      {/* ===== Banner Section ===== */}
      <section className="cp-hero">
        <h1 className="cp-title">Contact Sahyog Care</h1>
        <p className="cp-subtitle">
          Your trusted partner in premium home healthcare services
        </p>
      </section>

      {/* ===== Contact Section ===== */}
      <div className="cp-flexbox">
        {/* Left Info */}
        <div className="cp-details">
          <h2>Get In Touch</h2>
          <p className="cp-desc">
            Have questions or need assistance? Our team is here 24/7 to help you
            with home nursing, elder care, patient care, and rehabilitation services.
          </p>

          <div className="cp-info-card">
            <h3>📞 Phone</h3>
            <p>+91 8291008181</p>
          </div>

          <div className="cp-info-card">
            <h3>📧 Email</h3>
            <p>support@sahyogcare.com</p>
          </div>

          <div className="cp-info-card">
            <h3>📍 Address</h3>
            <p>
              Sahyog Care Home and Medical Servises, Plot no 10/11, near B S Bane School, Mhada,
              Vasant Vihar, old, Thane, Maharashtra 400610
            </p>
          </div>
        </div>

        {/* Right Form */}
        <div className="cp-form">
          <h2>Send Us a Message</h2>

          {successMsg && <p className="cp-success">{successMsg}</p>}
          {errorMsg && <p className="cp-error">{errorMsg}</p>}

          <form onSubmit={handleSubmit}>
            <div className="cp-field">
              <label>Your Name *</label>
              <input
                type="text"
                name="Name"
                value={formData.Name}
                onChange={handleChange}
                placeholder="Enter your name"
              />
            </div>

            <div className="cp-field">
              <label>Email Address *</label>
              <input
                type="text"  // <- Use text to avoid native browser validation
                name="EmailId"
                value={formData.EmailId}
                onChange={handleChange}
                placeholder="Enter your email"
              />
            </div>

            <div className="cp-field">
              <label>Phone Number *</label>
              <input
                type="text"
                name="Mobile"
                value={formData.Mobile}
                onChange={handleChange}
                placeholder="Enter your phone number"
              />
            </div>

            <div className="cp-field">
              <label>Your Message *</label>
              <textarea
                name="Comment"
                value={formData.Comment}
                onChange={handleChange}
                placeholder="Write your message here..."
              />
            </div>

            <button type="submit" className="cp-submit" disabled={loading}>
              {loading ? "Sending..." : "Submit Message"}
            </button>
          </form>
        </div>
      </div>

      {/* ===== Map Section ===== */}
      <div className="cp-map-section">
        <h2 className="cp-map-title">Our Location</h2>
        <p className="cp-map-subtitle">
          Visit us or reach out anytime — we are always here to help.
        </p>

        <div className="cp-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.0346376551937!2d72.9683915!3d19.224255!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b960d8e6035b%3A0xfd47f43683a1d3ac!2sSahyog%20care%20home%20and%20health%20services%2C%20old%20age%20home%2C%20assisted%20living%2C%20bed%20ridden%20patient%20care!5e0!3m2!1sen!2sin!4v1700480000000!5m2!1sen!2sin"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactPageNew;
